var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-bar-outer" }, [
    _c("div", { staticClass: "search-bar" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        staticClass: "bar",
        class: { invalid: _vm.invalid },
        attrs: {
          autocomplete: _vm.autocomplete ? "new-" + _vm.autocomplete : null,
          placeholder: _vm.dynamicPlaceholder,
          autocapitalize: "on",
          type: "search",
          enterkeyhint: "search",
        },
        domProps: { value: _vm.value },
        on: {
          keydown: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.handleEnterPress.apply(null, arguments)
          },
          input: _vm.handleInput,
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.disableClearButton === false && _vm.value.length > 0,
              expression: "disableClearButton === false && value.length > 0",
            },
          ],
          staticClass: "search-close",
          on: { click: _vm.handleClearClick },
        },
        [_c("div", { staticClass: "sd2-icons", class: _vm.clearIcon })]
      ),
      _vm._v(" "),
      _vm.cityName
        ? _c(
            "div",
            {
              staticClass: "city-select-button",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.triggerSuperDropdown.apply(null, arguments)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.cityName))]),
              _vm._v(" "),
              _c("i", {
                staticClass:
                  "sd2-icons arrow-down-big search-city-select-button-arrow",
              }),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-icon" }, [
      _c("div", { staticClass: "sd2-icons search" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }